var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "NewsSetting-container full-height" }, [
    _vm.checkPermission(["ITA-DEV", "ITA-ADMIN", "ITA-ADM-STAFF", "ITA-SALES"])
      ? _c(
          "div",
          [
            _c(
              "el-card",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "box-card",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", [_vm._v("加值服務介紹設定")]),
                    _c(
                      "el-button",
                      {
                        staticStyle: { float: "right", color: "#4b4b4b" },
                        attrs: { type: "warning" },
                        on: { click: _vm.saveData },
                      },
                      [_vm._v("儲 存")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-tabs",
                      {
                        attrs: { type: "border-card" },
                        model: {
                          value: _vm.tabName,
                          callback: function ($$v) {
                            _vm.tabName = $$v
                          },
                          expression: "tabName",
                        },
                      },
                      [
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "編輯", name: "edit" } },
                          [
                            _c(
                              "div",
                              [
                                _c("tinymce", {
                                  ref: "tinymce_newsSetting",
                                  staticStyle: { position: "relative" },
                                  attrs: {
                                    id: "tinymcePlan_newsSetting",
                                    height: 500,
                                    type: 33,
                                  },
                                  model: {
                                    value: _vm.content,
                                    callback: function ($$v) {
                                      _vm.content = $$v
                                    },
                                    expression: "content",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "預覽", name: "preview" } },
                          [
                            _c("div", { staticStyle: { height: "100%" } }, [
                              _c("div", {
                                staticClass: "full-height bg-text",
                                domProps: { innerHTML: _vm._s(_vm.content) },
                              }),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        )
      : _c("div", { staticClass: "view-div full-height" }, [
          _c("div", { staticClass: "bg-image" }),
          _c("div", { staticClass: "bg-text" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.content) } }),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }